<template lang="pug">
  Modal(ref="dlg" title="Ati Help" closeable="true")
    div.ati-help(v-pre)
      h2 Properties
      dl
        dt
          code code
        dd The code that was validated
        dt
          code codeIndex
        dd The index of the code in the order (Integer)
        dt
          code codeStatus
        dd Map of possible statuses assigned to this code (Map)
        dt
          code validationNo
        dd The number of times the code has been validated including the current one
        dt
          code maxValidations
        dd The maximum number of allowed validations
        dt
          br
          code section
        dd
          dl
            dt
              code id
            dd The ID of section
            dt
              code activate
            dd The date/time this section is active from
            dt
              code deactivate
            dd The date this section is no longer active
            dt
              code totalNumberOfCodes
            dd The total number of codes in this section
            dt
              code firstCodeIndex
            dd The index of the first code in this section
            dt
              code lastCodeIndex
            dd The index of the last code in this section
            dt
              code metadata
            dd
              | Assigned metadata, the structure differs for different schemas. All properties can be accessed through dot (.) notation.
        dt
          br
          code order
        dd
          dl
            dt
              code id
            dd The ID of the order
            dt
              code locked
            dd Whether the order is locked, i.e. it cannot be added more codes to (boolean)
            dt
              code description
            dd A textual description of this order
            dt
              code totalNumberOfCodes
            dd The total number of codes in this order (integer)
            dt
              code sectioned
            dd Whether the order is sectioned (boolean)
            dt
              code metadata
            dd
              | Assigned metadata, the structure differs for different schemas. All properties can be accessed through dot (.) notation.
        dt
          br
          code product
        dd
          dl
            dt
              code id
            dd The ID of the product
            dt
              code alias
            dd The assigned alias of the product
            dt
              code name
            dd The name of the product
            dt
              code gtin
            dd The GTIN of the product
            dt
              code netWeight
            dd The net weight of the product
            dt
              code grossWeight
            dd The gross weight of the product
            dt
              code packageType
            dd
              | The package type of the product
              dl
                dt
                  code id
                dd The ID of the package type
                dt
                  code type
                dd The type of package, for example pallett, box, drum, etc
                dt
                  code description
                dd A description of the package type
                dt
                  code dryWeight
                dd The dry weight of the package (without contents)
                dt
                  code material
                dd The material type of the package
            dt
              code metadata
            dd
              | Assigned metadata, the structure differs for different schemas. All properties can be accessed through dot (.) notation.
      h2 Filters
      dl
        dt
          code abs
        dd The abs filter is used to obtain the absolute value.
        dt
          code capitalize
        dd The capitalize filter will capitalize the first letter of the string.
        dt
          code date
        dd The date filter is used to format an existing date object or an ISO date string
        dt
          code first
        dd
          | The first filter will return the first item of a collection, or the first letter of a string.
        dt
          code join
        dd
          | The join filter will concatenate all items of a collection into a string. An optional argument can be given to be used as the separator between items.
        dt
          code last
        dd
          | The last filter will return the last item of a collection, or the last letter of a string.
        dt
          code lower
        dd The lower filter makes an entire string lower case.
        dt
          code numberformat
        dd The numberformat filter is used to format a decimal number
        dt
          code raw
        dt
          code slice
        dd The slice filter returns a portion of a list, array, or string.
        dt
          code sort
        dd
          | The sort filter will sort a list. The items of the list must implement Comparable.
        dt
          code title
        dd The title filter will capitalize the first letter of each word.
        dt
          code trim
        dd
          | The trim filter is used to trim whitespace off the beginning and end of a string.
        dt
          code upper
        dd The upper filter makes an entire string upper case.
        dt
          code urlencode
        dd
          | The urlencode translates a string into application/x-www-form-urlencoded format using the "UTF-8" encoding scheme.
      h2 Functions
      dl
        dt
          code max
        dd The max function will return the smallest of it's numerical arguments.
        dt
          code min
        dd The min function will return the smallest of it's numerical arguments.
      h2 Tags
      dl
        dt
          code if/else/endif
        dd
          | Allows for conditional evalution:
          code {% if var == "a" %} Yes! {% else %} No! {% endif %}
        dt
          code for/else/endfor
        dd
          | Iterate a list or anything iterable.
          code {% for x in mylist %}Value: {{x}}{% endfor %}
        dt
          code filter/endfilter
        dd
          | The filter tag allows you to apply a filter to a large chunk of a template.
          code {% filter lower | capitalize | trim %} my content goes in here {% endfilter %}
      h2 Examples
      h3 Placeholders
      code
        | This {{code}} is valid! The product was {{product.name}}, and it has been validated {{validationNo | numberformat}} times out of {{maxValidations | numberformat}}.
      h3 Conditionals
      codeblock
        | {% if codeStatus[4] is not empty %}
        | This code has been rejected
        | {% else %}
        | All good!
        | {% endif %}
      h3 Metadata
      code
        | Code {{code}} is valid for {{product.name}} {{section.metadata.dosage}} mg. Manufacturing date was {{section.metadata.manufacturingDate | date('yyyy-MM-dd')}}
      h3 Time of activation/deactivation
      dd
        | An expression refering to the date value of a metadata schema propery
        code /expiryDate, /productionDate
        | etc ...
</template>

<script>
import Modal from '@/components/common/Modal'

export default {
  methods: {
    open() {
      this.$refs.dlg.open()
    },
    close() {
      this.$refs.dlg.cancel()
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="scss">
.ati-help {
  codeblock {
    font-family:Menlo,Monaco,Consolas,"Courier New",monospace;
    white-space:pre;
    padding:2px 4px;
    font-size:90%;
    color:#c7254e;
    background-color:#f9f2f4;
    border-radius:4px}
  dl > dd > dl {
    padding-left:32px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/core/ati/AtiHelpModal.vue